'use client';

import { CartProvider } from '@/app/lib/papa/cardapio/cart-context';
import Image from 'next/image';
import '@/app/ui/papa/cardapio/cardapio.css';
import Link from 'next/link';

export default function CardapioLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="pt-BR">
      <head>        
        <link href="https://fonts.googleapis.com/css2?family=Fredoka:wght@300;400;500;600&amp;family=Nunito:wght@400;600;700&amp;display=swap" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@48,400,0,0" rel="stylesheet" />
      </head>
      <body className="flex flex-col min-h-screen">
        <CartProvider>
          <header className="cardapio-header">
            <Image src="/LogoSmall.png" unoptimized alt="Logo" width={150} height={30} />
          </header>
          <div className='flex-grow'>
            {children}
          </div>
        </CartProvider>
        <footer className="mt-auto border-t border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <p className="text-center text-sm text-secondary-text-light dark:text-secondary-text-dark">
              © 2025 Meu Papa. Todos os direitos reservados.
            </p>
          </div>
        </footer>
      </body>
    </html>
  );
}

